import { render, staticRenderFns } from "./Korisnici.vue?vue&type=template&id=4cee13bf&scoped=true&"
import script from "./Korisnici.vue?vue&type=script&lang=ts&"
export * from "./Korisnici.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cee13bf",
  null
  
)

export default component.exports